import chunk from 'lodash/chunk';
import merge from 'lodash/merge';
import isEqual from 'lodash/isEqual';
import { REHYDRATE } from 'redux-persist/lib/constants';
import qs from 'qs';
import { getDefaultQuery, buildQuery, parseProductQueryString } from '../../utils/products.js';
import { storageAvailable } from '../../components/common/storageAvailable';
import { isMarketing } from '../../utils/pdp';

export default function grid(
  state = {
    results: [],
    entities: {},
    gridColumns: 2,
    gridResults: [],
    gridColumnWidth: 158,
    gridRowHeight: 321,
    gridRowCount: 20,
    gridWidth: 320,
    viewType: 'outfitview',
    cacheInvalid: true,
    closedFacetGroups: [],
    openFacets: [],
    loadingMoreItems: false
  },
  action
) {
  const { type } = action;
  if (type === 'SET_GRID_DATA') {
    const { idKey, data = [], query = {}, plpViewType } = action;
    const gridColumns = getGridColumns(state, query, plpViewType);
    if (data && Array.isArray(data) && data.length > 0) {
      let nextState = data.reduce(
        (acc, item, key) => {
          const k = item[idKey] || key;
          acc.results.push(k);
          acc.entities[k] = item;
          return acc;
        },
        {
          results: [],
          entities: {}
        }
      );

      if (nextState && nextState.results && nextState.results.length > 0) {
        nextState.gridResults = chunk(nextState.results, gridColumns);
        nextState.gridRowCount = nextState.gridResults.length;
      }
      nextState = { ...state, ...nextState, gridColumns };
      return { ...nextState };
    }
  } else if (type === 'APPEND_DATA_TO_GRID') {
    const { idKey, data = [], query = {} } = action;
    const gridColumns = getGridColumns(state, query);
    if (data && Array.isArray(data) && data.length > 0) {
      let nextState = data.reduce(
        (acc, item, key) => {
          const k = item[idKey] || key;
          acc.results.push(k);
          acc.entities[k] = item;
          return acc;
        },
        {
          results: [...state.results],
          entities: { ...state.entities }
        }
      );

      if (nextState && nextState.results && nextState.results.length > 0) {
        nextState.gridResults = chunk(nextState.results, gridColumns);
        nextState.gridRowCount = nextState.gridResults.length;
      }
      nextState = { ...state, ...nextState, gridColumns };
      return { ...nextState };
    }
  } else if (action.type === 'LOADING_MORE_PRODUCTS_ON_SCROLL') {
    const { loadingMoreItems } = action;
    let nextState = { ...state };
    nextState.loadingMoreItems = loadingMoreItems;
    return nextState;
  } else if (type === 'SET_GRID_COLUMN') {
    const { gridColumns } = action;
    if (gridColumns && gridColumns !== state.gridColumns) {
      let nextState = { ...state };
      if (nextState && nextState.results && nextState.results.length > 0) {
        nextState.gridResults = chunk(nextState.results, gridColumns);
        nextState.gridRowCount = nextState.gridResults.length;
        nextState = { ...state, ...nextState, gridColumns };
        return { ...nextState };
      }
    }

    return state;
  } else if (type === 'SET_VIEW_TYPE') {
    const { viewType } = action;
    const nextState = { ...state };
    nextState.viewType = viewType;
    return nextState;
  } else if (type === 'SET_GRID_CONFIG') {
    const { values } = action;
    let nextState = { ...state, ...values };
    if (
      values.gridColumns &&
      values.gridColumns != state.gridColumns &&
      nextState.results &&
      nextState.results.length > 0
    ) {
      nextState.gridResults = chunk(nextState.results, values.gridColumns);
      nextState.gridRowCount = nextState.gridResults.length;
    }
    return { ...nextState };
  } else if (action.type === 'TOGGLE_FACET_GROUPS') {
    const { id } = action;
    const newState = { ...state };
    newState.closedFacetGroups = newState.closedFacetGroups || [];
    newState.closedFacetGroups = [...newState.closedFacetGroups];
    const index = newState.closedFacetGroups.indexOf(id);
    if (index > -1) {
      newState.closedFacetGroups.splice(index, 1);
    } else {
      newState.closedFacetGroups.push(id);
    }
    return newState;
  } else if (action.type === 'TOGGLE_FACET') {
    const { id } = action;
    const newState = { ...state };
    newState.openFacets = newState.openFacets || [];
    newState.openFacets = [...newState.openFacets];
    const index = newState.openFacets.indexOf(id);
    if (index > -1) {
      newState.openFacets.splice(index, 1);
    } else {
      newState.openFacets.push(id);
    }
    return newState;
  } else if (type === REHYDRATE) {
    const { payload = {} } = action;
    const { grid = {}, request = {} } = payload;
    const { results = [] } = grid;
    let { query: prevQuery = {} } = request;
    const location = window.location || {};
    if (storageAvailable('localStorage')) {
      var storageRequest = localStorage.getItem('plpRequestMobile');
    }
    if (storageRequest) {
      try {
        storageRequest = JSON.parse(storageRequest);
      } catch (e) {}
    }
    storageRequest = storageRequest || {};
    const blackList = [
      'hash',
      'gridColumns',
      'viewType',
      'fields',
      'currentPage',
      'pageSize',
      'format',
      'facets'
    ];
    prevQuery = buildQuery(prevQuery, {
      defaultQuery: getDefaultQuery(),
      blackList
    });
    let locationQuery = qs.parse(location.href.split('?')[1] || '');
    if (locationQuery && (locationQuery.query || locationQuery.q)) {
      locationQuery.query = locationQuery.query || locationQuery.q;
    } else if (
      storageRequest.href &&
      storageRequest.href == location.href &&
      storageRequest.request &&
      storageRequest.request.query
    ) {
      locationQuery = storageRequest.request.query;
    }
    let currQuery = buildQuery(locationQuery, {
      defaultQuery: getDefaultQuery(),
      blackList
    });
    const { pathname: locPathName = '', search = '' } = location;
    const { browserPath: reqPathName = '' } = request;
    const locPathSplits = locPathName.split('/');
    const reqPathSplits = reqPathName.split('/');

    if (
      locPathName.includes('/search') &&
      !currQuery.query.includes(currQuery.currSearch || request.freeTextSearch)
    ) {
      currQuery.query = `${currQuery.currSearch || request.freeTextSearch}${currQuery.query}`;
    }
    // If Product Page
    if (isMarketing(search) && locPathSplits.indexOf('p') !== -1) {
      return { ...state };
    }

    currQuery = {
      ...currQuery,
      ...parseProductQueryString(currQuery.query || '')
    };

    prevQuery = {
      ...prevQuery,
      ...parseProductQueryString(prevQuery.query || '')
    };

    if (results.length < 1) {
      return { ...state };
    }
    if (['capsule', 'cp', 'wishlist', 'cart'].includes(locPathSplits[1])) {
      return { ...state };
    }
    if (
      location.pathname == request.browserPath &&
      ((request &&
        request.deviceType === 'mobile' &&
        ['search', 's'].includes(locPathSplits[1]) &&
        currQuery.text == prevQuery.text) ||
        isEqual(currQuery, prevQuery)) &&
      isDeviceMatch(grid)
    ) {
      return {
        ...grid,
        gridColumnWidth: state.gridColumnWidth || grid.gridColumnWidth,
        gridRowHeight: state.gridRowHeight || grid.gridRowHeight,
        gridWidth: state.gridWidth || grid.gridWidth,
        cacheInvalid: state.cacheInvalid || grid.cacheInvalid
      };
    }
    if (
      locPathSplits[1] != reqPathSplits[1] &&
      !['search', 'c', 'b', 's', 'find', 's1'].includes(locPathSplits[1]) &&
      !['c'].includes(locPathSplits[2]) &&
      isDeviceMatch(grid)
    ) {
      return {
        ...grid,
        gridColumnWidth: state.gridColumnWidth || grid.gridColumnWidth,
        gridRowHeight: state.gridRowHeight || grid.gridRowHeight,
        gridWidth: state.gridWidth || grid.gridWidth,
        cacheInvalid: state.cacheInvalid || grid.cacheInvalid
      };
    }

    return { ...state };
  }
  return state;
}

function isDeviceMatch(grid) {
  let isMatched = false;
  if (!navigator) {
    isMatched = true;
  } else if (
    (!isMobile() && [3, 5].includes(parseInt(grid.gridColumns))) ||
    (isMobile() && [2].includes(parseInt(grid.gridColumns)))
  ) {
    isMatched = true;
  }
  return isMatched;
}

function isMobile() {
  let mobileDevice = false;
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    mobileDevice = true;
  }
  return mobileDevice;
}

function getGridColumns(state = {}, query = {}, plpViewType) {
  let gridColumns = 2;
  if (query.gridColumns) {
    gridColumns = parseInt(query.gridColumns);
  } else if (state.gridColumns) {
    gridColumns = parseInt(state.gridColumns);
  }
  gridColumns = plpViewType == 'list' ? gridColumns / 2 : gridColumns;
  return gridColumns;
}
